/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllQueryableTablesResponse } from '../../models/get-all-queryable-tables-response';

export interface GetAllQueryableTables$Params {
}

export function getAllQueryableTables(http: HttpClient, rootUrl: string, params?: GetAllQueryableTables$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllQueryableTablesResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllQueryableTables.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllQueryableTablesResponse>;
    })
  );
}

getAllQueryableTables.PATH = '/v1/graphql/queryableTables';
